import { msalInstance } from '..';

/**
 * Utility for generating and managing correlation IDs
 * Correlation IDs are tied to the user session for better traceability
 */
export class CorrelationUtils {
  private static sessionId: string | null = null;
  private static requestCounter = 0;
  private static currentDate: string | null = null;

  /**
   * Gets or creates a session ID based on the current user and date
   * Session ID remains stable for the entire day per user
   * @returns string - The session ID
   */
  private static getSessionId(): string {
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    
    // Reset session if it's a new day
    if (this.currentDate !== today) {
      this.sessionId = null;
      this.requestCounter = 0;
      this.currentDate = today;
    }
    
    if (!this.sessionId) {
      const account = msalInstance.getActiveAccount();
      const userId = account?.homeAccountId || account?.localAccountId || 'anonymous';
      this.sessionId = `${userId}-${today}`;
    }
    return this.sessionId;
  }

  /**
   * Generates a correlation ID for a request
   * Option 1: Same correlation ID for the whole day per user
   * Option 2: Day-based session ID with request counter for individual request tracking
   * @param includeRequestCounter - If true, includes request counter for individual request tracking
   * @returns string - The correlation ID
   */
  public static generateCorrelationId(includeRequestCounter: boolean = false): string {
    const sessionId = this.getSessionId();
    
    if (includeRequestCounter) {
      this.requestCounter++;
      return `${sessionId}-${this.requestCounter}`;
    }
    
    // Same correlation ID for the whole day
    return sessionId;
  }
} 